import React, {  useState } from "react";


import { CustomDialog } from "components/Dialogs";
import PreloaderBlur from "containers/PeopleCraft/PreloaderBlur";

import { useToast } from "hooks/useToast";
import { forgotEmailSecondary } from "services/NexiDigitalAPISecondary";
import { getAppType } from "utils/Utils";

import "./style.scss";

type ResetPasswordEmailModalProps = {
  controlModalAcitionOpen: boolean;
  setControlModalAcitionOpen?: (active: boolean) => void;
  item: {
    name: string;
    email: string;
    username: string;
  };
};

const ResetPasswordEmailModal: React.FC<ResetPasswordEmailModalProps> = ({
  controlModalAcitionOpen,
  setControlModalAcitionOpen,
  item,
}) => {
  const [loading, setLoading] = useState(false);

  const { error, success } = useToast();

  const handleClickConfirmAction = () => {
    setControlModalAcitionOpen(false);
    setLoading(true);
    forgotEmailSecondary({
      username: item.username,
      email: item.email,
      idAppType: getAppType(),
    })
      .then(({ data }) => {
        success("E-mail de redefinição de senha enviado com sucesso!");
      })
      .catch((e) => error("Erro ao enviar e-mail de redefinição de senha."))
      .finally(() => setLoading(false));
  };

  return (
    <>
      <CustomDialog
        show={controlModalAcitionOpen}
        onClose={() => setControlModalAcitionOpen(false)}
        title={"Enviar e-mail de redefinição de senha?"}
        description={`<div class="elementMenssageCustomDialog">
                            <p>
                              Um e-mail com link para redefinição de senha será enviado para o(a)${" "}
                              <strong>${item.name}</strong> com instruções de como trocar a senha.
                            </p>
                            <p>
                              <strong class="text-danger">Ao confirmar, o envio é imediato.</strong>
                              <span> Deseja continuar?</span>
                            </p>
                          </div>`}
        iconType="warning"
        buttons={[
          {
            label: "Enviar",
            onClick: () => handleClickConfirmAction(),
            variant: "primary",
            style: { color: "#F7F7F7", backgroundColor: "#6649F2", borderColor: "#6649F2" },
          },
        ]}
      />

      {loading && <PreloaderBlur />}
    </>
  );
};

export default ResetPasswordEmailModal;
